export default {
  global: {
    list: {
      title: "Liste des {name}",
    },
    view: {
      title: ({ plural, named }) => plural([`Données du ${named("name")}`, `Données d'une ${named("name")}`]),
    },
    add: {
      title: ({ plural, named }) => plural([`Ajouter un ${named("name")}`, `Ajouter une ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} ajouté avec succès !`, `${named("name")} ajoutée avec succès !`]),
    },
    accept: {
      title: ({ plural, named }) => plural([`Accepter un ${named("name")}`, `Accepter une ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} accepté avec succès !`, `${named("name")} acceptée avec succès !`]),
    },
    decline: {
      title: ({ plural, named }) => plural([`Refuser un ${named("name")}`, `Refuser une ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} refusé avec succès !`, `${named("name")} refusée avec succès !`]),
    },
    edit: {
      title: ({ plural, named }) =>
        plural([`Modifier la ${named("name")}`, `Modifier un ${named("name")}`, `Modifier une ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} modifié avec succès !`, `${named("name")} modifiée avec succès !`]),
    },
    unactive: {
      title: ({ plural, named }) =>
        plural([`Désactiver la ${named("name")}`, `Désactiver un ${named("name")}`, `Désactiver une ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Êtes-vous sûr de vouloir Désactiver cet ${named("name")}`,
          `Êtes-vous sûr de vouloir Désactiver cette ${named("name")}`,
          `Êtes-vous sûr de vouloir Désactiver ${named("name")}`,
        ]),
      success: ({ plural, named }) =>
        plural([`${named("name")} désactivé avec succès !`, `${named("name")} désactivée avec succès !`]),
    },
    regenerate: {
      errors: "Erreur lors de la régénération",
      title: ({ plural, named }) => plural([`Régénérer un ${named("name")}`, `Régénérer une ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} régénéré avec succès !`, `${named("name")} régénérée avec succès !`]),
    },
    active: {
      title: ({ plural, named }) =>
        plural([`Activer la ${named("name")}`, `Activer un ${named("name")}`, `Activer une ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Êtes-vous sûr de vouloir activer cet ${named("name")}`,
          `Êtes-vous sûr de vouloir activer cette ${named("name")}`,
          `Êtes-vous sûr de vouloir activer ${named("name")}`,
        ]),
      success: ({ plural, named }) =>
        plural([`${named("name")} activé avec succès !`, `${named("name")} activée avec succès !`]),
    },
    import: {
      errors: "Votre fichier contient des erreurs, veuillez les corriger et relancer l'import",
      title: "Importer des {name}",
      error: "Erreur ligne {line} colonne {column} :",
      success: ({ plural, named }) =>
        plural([`${named("name")} importés avec succès !`, `${named("name")} importées avec succès !`]),
    },
    ypareo: {
      title: "Dernière synchronisation le : {date}",
      title_failure: "Échec de la synchronisation. Dernière tentative effectuée le : {date}",
    },
    export: {
      title: "Exporter les {name}",
      title_singular: "Exporter le {name}",
      title_alone: "Exporter",
      success: ({ plural, named }) =>
        plural([`${named("name")} exportés avec succès !`, `${named("name")} exportées avec succès !`]),
    },
    update: {
      title: "Compléter vos {name}",
      success: "{name} complété avec succès !",
    },
    search: {
      title: "Rechercher des {name}",
      reset_filters: "Réinitialiser les filtres",
    },
    sort: {
      success: "Ordre des {name} mis à jour avec succès !",
    },
    download: {
      success: "{name} téléchargé avec succès !",
      title: "Télécharger le {name}",
      done: "Téléchargement terminé",
      error: "Une erreur est survenue lors du téléchargement",
    },
    move: {
      success: ({ plural, named }) =>
        plural([`${named("name")} déplacé avec succès !`, `${named("name")} déplacée avec succès !`]),
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} dupliqué avec succès !`, `${named("name")} dupliquée avec succès !`]),
      title: ({ plural, named }) => plural([`Dupliquer ce ${named("name")}`, `Dupliquer cette ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Êtes-vous sûr de vouloir dupliquer ce ${named("name")}`,
          `Êtes-vous sûr de vouloir  dupliquer cette ${named("name")}`,
        ]),
    },
    empty: {
      title: ({ plural, named }) =>
        plural([
          `Il n'y a pas encore de ${named("name1")} dans ce ${named("name2")}, veuillez cliquer sur '+' pour en ajouter une`,
          `Il n'y a pas encore de ${named("name1")} dans cette ${named("name2")}, veuillez cliquer sur '+' pour en ajouter un`,
          `Il n'y a pas encore de ${named("name1")} dans cette ${named("name2")}, veuillez cliquer sur '+' pour en ajouter une`,
        ]),
      dashboard: "Il n'y a pas encore de {name}",
      no_data_available: "Aucune donnée disponible",
    },
    delete: {
      title_alone: "Supprimer",
      title: ({ plural, named }) =>
        plural([`Supprimer ${named("name")}`, `Supprimer un ${named("name")}`, `Supprimer une ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Êtes-vous sûr de vouloir supprimer un ${named("name")} ?`,
          `Êtes-vous sûr de vouloir supprimer une ${named("name")} ?`,
          `Êtes-vous sûr de vouloir supprimer ${named("name")} ?`,
        ]),
      success: ({ plural, named }) =>
        plural([
          `${named("name")} supprimé avec succès !`,
          `${named("name")} supprimée avec succès !`,
          `${named("name")} supprimés avec succès !`,
          `${named("name")} supprimées avec succès !`,
        ]),
    },
    valid: {
      title: ({ plural, named }) =>
        plural([`Valider le ${named("name")}`, `Valider la ${named("name")}`, `Valider l'${named("name")}`]),
    },
    unvalid: {
      title: ({ plural, named }) =>
        plural([`Invalider le ${named("name")}`, `Invalider la ${named("name")}`, `Invalider l'${named("name")}`]),
    },
    opened: {
      title: ({ plural }) => plural(["Ouvert", "Ouverte", "Ouverts", "Ouvertes"]),
    },
    closed: {
      title: ({ plural }) => plural(["Fermé", "Fermée", "Fermés", "Fermées"]),
    },

    label: {
      name: "Nom",
      date: "Date",
      triads: "Trinômes",
      trainings: "Formations",
    },
    actions: {
      title: "Actions",
      empty: "Aucune action n'est disponible pour le moment",
    },
    see_more: "Voir plus...",
    see_less: "Voir moins...",
    see_detail: "Afficher/Cacher les détails",
    collapse_show: "Afficher",
    collapse_reduce: "Réduire",
    close: "Fermer",
    duration: "Durée",
    period: "Période",
    show_hide_actions: "Afficher / Cacher les actions",
    show_hide_caption: "Afficher / Cacher la légende",
    visible: "Visible",
    visible_by: "Visible par",
    hidden: "Invisible",
    send: "Envoyer",
    send_mail: "Envoyer un mail",
    send_opco: "Soumettre à l'OPCO",
    valid_file: "Valider le dossier",
    language: {
      change: "Changer de langue ({language})",
      french: "Français",
      english: "Anglais",
      spanish: "Espagnol",
      german: "Allemand",
    },
    stats: "Statistiques",
    setting: "Paramétrage",
    module: "Modules",
    control: "Pilotage",
    light: "Clair",
    dark: "Sombre",
    caption: {
      title: "Légende",
    },
    home_alert: {
      title: "Information",
      do_not_show_agin: "Ne plus afficher cette alerte",
    },
    entity: {
      contact: {
        title: ({ plural }) => plural(["Contact", "Contacts"]),
      },
    },
    menu: {
      studea_manager_area: "Pilotage de la promotion",
      admin_area: "Espace administrateur",
    },
    total: "Total",
    totalCompany: "Total à la charge de l'employeur (participation obligatoire + reste à charge)",
    table: {
      filtered_result: ({ plural }) => plural(["résultat filtré", "résultats filtrés"]),
    },
    user: {
      activate: {
        success: "Utilisateur activé avec succès !",
      },
    },
    other: ({ plural }) => plural(["Autre", "Autres"]),
    data_table: {
      filtered_result: ({ plural, named }) =>
        plural([`(${named("count")} résultat filtré)`, `(${named("count")} résultats filtrés)`]),
      filter_active: "(filtre actif)",
      select_all: "Tout sélectionner",
      select_line: "Sélectionner la ligne",
      year: ({ named }) => `Année ${named("year")}`,
    },
    expand: "Développer",
    collapse: "Réduire",
    drag_to_reorder: "Glisser pour réordonner",
    comments: "Commentaires",
    support: "Accéder au support STUDEA",
    new_window: "(ouvre dans une nouvelle fenêtre)",
    historic: {
      title: "Historique",
    },
    aria_label_separator: " — ",
  },
  breadcrumb: {
    home: "Accueil",
  },
  loading: "Chargement en cours",
};
